import { Component, OnInit } from '@angular/core';
import { MerchantProfilesNewComponent } from './merchant-profiles-new.component';
import { ActivatedRoute, Router } from '@angular/router';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { Location } from '@angular/common';
import {
  AlertService,
  BankAccountConnectionService,
  CampaignService,
  MerchantCategoryService,
  MerchantProfileService,
  PaymentSourceService,
  RegionService,
  UserService,
} from '../_services';
import { FormBuilder } from '@angular/forms';
import { MerchantProfile } from '../_models';

@Component({
  selector: 'app-merchant-profiles-edit',
  templateUrl: './merchant-profiles-edit.component.html',
  styleUrls: [
    './merchant-profiles-edit.component.scss',
    '../checkouts/checkout-profiles/profiles-styles.component.scss',
  ],
  animations: [
    trigger('fadeIn', [
      state('void', style({ opacity: 0 })),
      transition(':enter', [animate('500ms ease-in', style({ opacity: 1 }))]),
    ]),
    trigger('expandCollapse', [
      state('collapsed', style({ height: '0px', opacity: 0, display: 'none' })),
      state('expanded', style({ height: '*', opacity: 1 })),
      transition('collapsed <=> expanded', animate('250ms ease-in-out')),
    ]),
  ],
})
export class MerchantProfilesEditComponent extends MerchantProfilesNewComponent implements OnInit {
  constructor(
    protected router: Router,
    protected location: Location,
    protected route: ActivatedRoute,
    protected merchantProfileService: MerchantProfileService,
    protected alertService: AlertService,
    protected formBuilder: FormBuilder,
    protected campaignService: CampaignService,
    protected merchantCategoryService: MerchantCategoryService,
    protected userService: UserService,
    protected regionService: RegionService,
    protected paymentSourceService: PaymentSourceService,
    protected bankAccountConnectionService: BankAccountConnectionService
  ) {
    super(
      router,
      location,
      route,
      merchantProfileService,
      alertService,
      formBuilder,
      campaignService,
      merchantCategoryService,
      userService,
      regionService,
      paymentSourceService,
      bankAccountConnectionService
    );
    this.isNew = false;
  }

  ngOnInit() {
    super.ngOnInit();
    this.loading = true;

    this.data$.subscribe(
      (profile: MerchantProfile) => {
        if (profile && profile.id) {
          this.applyProfile(profile);
        }

        this.loading = false;
      },
      (error) => {
        this.handleError(error);
        this.loading = false;
      }
    );
  }
}
